import { Appliance } from '@hakimo-ui/hakimo/types';
import { Link } from 'react-router-dom';
import { dash, humanizeType, statusDotClass } from './util';

interface Props {
  appliance: Appliance;
}

const cardClasses =
  'dark:bg-ondark-bg-2 bg-onlight-bg-2 block break-words rounded-lg p-4 text-left shadow-sm';

export function ApplianceCard(props: Props) {
  const { appliance } = props;

  const body = (
    <>
      <div className="flex items-center gap-2">
        <span
          className={`h-2 w-2 rounded-full ${statusDotClass(
            appliance.hostStatus
          )}`}
        />
        <h3 className="dark:text-ondark-text-1 text-onlight-text-1 min-w-0 text-sm font-semibold">
          {appliance.applianceName}
        </h3>
      </div>
      <p className="dark:text-ondark-text-2 text-onlight-text-2 mt-1 text-xs">
        {humanizeType(appliance.applianceType)}
      </p>
      <dl className="dark:text-ondark-text-2 text-onlight-text-2 mt-4 space-y-1 text-xs">
        <div className="flex justify-between gap-4">
          <dt className="shrink-0">Tenant</dt>
          <dd className="min-w-0 text-right">{dash(appliance.tenantName)}</dd>
        </div>
        <div className="flex justify-between gap-4">
          <dt className="shrink-0">VPN IP</dt>
          <dd className="min-w-0 text-right">{dash(appliance.openvpnIp)}</dd>
        </div>
        <div className="flex justify-between gap-4">
          <dt className="shrink-0">FRP port</dt>
          <dd className="min-w-0 text-right">{dash(appliance.frpPort)}</dd>
        </div>
      </dl>
    </>
  );

  return (
    <Link
      to={String(appliance.id)}
      className={`${cardClasses} dark:hover:bg-ondark-bg-3 hover:bg-onlight-bg-3`}
    >
      {body}
    </Link>
  );
}

export default ApplianceCard;
